import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=05d06f33&scoped=true&"
import script from "./Placeholder.vue?vue&type=script&lang=ts&"
export * from "./Placeholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d06f33",
  null
  
)

export default component.exports